import React, { useState, useRef, useEffect } from 'react'; // 1. Cambiado a useRef
import { Main } from '../Helpers/importacionesComunes'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye } from '@fortawesome/free-regular-svg-icons';
import { IdentificationIcon } from "@heroicons/react/24/solid";
import { Card, Input, Button, Typography } from "@material-tailwind/react";
import Logo from '../componentes/Logo';
import TurnstileWidget from './TurnstileWidget';
import Swal from 'sweetalert2'; // Para consistencia con el primer código
import { v4 as uuidv4 } from 'uuid';
import { Box } from "@material-ui/core";
import Alert from '@mui/material/Alert';

export default function Login({ login, mostrarError, error,isIOSWebView }) {
    // 2. Quitamos password del estado para usar la Ref y ocultar el valor en el inspect
    const [datosLogin, setdatosLogin] = useState({ username: '' });
    const [verPassword, setVerPassword] = useState('password');
    const [captchaToken, setCaptchaToken] = useState(null); 
    const passwordRef = useRef(null); // 3. Referencia para evitar re-renders
    const [keyTurnstile,setKeyTurnstile] = useState(0)

    const handleInputChange = (e) => {
        setdatosLogin({ ...datosLogin, [e.target.name]: e.target.value });
    };

    async function handleSubmit(e) {
        e.preventDefault();

        if (!captchaToken) {
            Swal.fire({ icon: 'warning', text: 'Por favor complete la validación de seguridad.' });
            return;
        }

        try {
            // 4. Usamos passwordRef.current.value y captchaToken
            await login(
                datosLogin.username, 
                passwordRef.current.value, 
                captchaToken
            );
            setCaptchaToken(null); 
        } catch (err) {
            setCaptchaToken(null);
            setKeyTurnstile(keyTurnstile + 1)
        }
    }

    return (
        <Main center>
            <div className="flex justify-center mt-20">
                <Typography variant="h4" color="blue-gray">Sistema Administrativo - UAD</Typography>
            </div>
            <div className="h-screen mt-10 flex flex-col items-center">
                <Card className="FormContainer border-[#EBEBEB] border-[1px] login !w-[670px] shadow-lg bg-white p-8">
                    <div className='flex justify-center'><Logo /></div>
                    <p className="FormContainer__info mt-8 text-center">Login integrado</p>
                    
                    <form onSubmit={handleSubmit}>
                        <Typography variant="small" color="blue-gray" className="mb-1 font-medium">Usuario</Typography>
                        <Input
                            name="username"
                            onChange={handleInputChange}
                            icon={<IdentificationIcon className="h-4 w-4 text-blue-gray-300" />}
                            placeholder="Usuario"
                        />
                        
                        <div className='relative mt-3'>
                            <Typography variant="small" color="blue-gray" className="mb-1 font-medium">Contraseña</Typography>
                            <Input
                                type={verPassword}
                                inputRef={passwordRef} // 5. Conexión con la Referencia
                                placeholder="Contraseña"
                                autoComplete="current-password"
                            />
                            <FontAwesomeIcon
                                icon={faEye}
                                color='gray'
                                className='absolute right-[12px] top-[36px] cursor-pointer'
                                onClick={() => setVerPassword(verPassword === 'password' ? 'text' : 'password')}
                            />
                        </div>

                        <Button className="mt-6 bg-[#111] w-full" type="submit">Ingresar</Button>
                    </form>

                    <div className='mt-5 flex justify-center'>
                        <TurnstileWidget
                            key={keyTurnstile} // Para forzar que se re-renderice cuando hay un error
                            siteKey={process.env.REACT_APP_CLOUDFLARE_PUBLIC_KEY}
                            action="login_admin"
                            onToken={setCaptchaToken} // 6. Widget centralizado
                        />
                    </div>
                    
                    {error && <Typography color="red" className="mt-4 text-center">{error}</Typography>}
                </Card>
                {/* <Warning/> */}
            </div>
        </Main>
    );
}

const Warning = ()=>{
    return             <Box className="w-full max-w-[670px] mx-auto mt-8 p-4 flex flex-col items-center text-center">
                <Alert variant="filled" severity="warning" className="w-full mb-4">
                    <strong>Importante:</strong>
                    <p>
                    Por motivos de seguridad, varios intentos fallidos de acceso pueden producir el bloqueo temporal de la dirección IP. Si esto ocurre, comuníquese con el administrador.
                    </p>
                </Alert>

                <p className="font-medium text-gray-700">
                    Para agilizar la asistencia, por favor envíe:
                </p>

                <ul className="list-disc list-inside text-left my-3 space-y-1">
                    <li>Nombre de usuario.</li>
                    <li>Dirección IP pública.</li>
                    <li>Captura de pantalla del error.</li>
                    <li>Hora aproximada en que ocurrió.</li>
                </ul>

                <p className="text-sm text-gray-600">
                    Puede conocer su IP pública ingresando a:{' '}
                    <a 
                    href="https://api.ipify.org" 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="text-blue-600 underline font-semibold hover:text-blue-800"
                    >
                    https://api.ipify.org
                    </a>
                </p>
            </Box>
}